export default {
  de: {
    imageCropper: {
      activate: "Auswahl eines Bildausschnitts aktivieren",
      close: "Schließen",
      copiedToClipboard: "Erfolgreich in die Zwischenablage kopiert",
      copyToClipboard: "In die Zwischenablage kopieren",
      deactivate: "Auswahl eines Bildausschnitts deaktivieren",
      linkToSelectedRegion: "Link zum ausgewählten Ausschnitt",
      mirror: "Bild spiegeln",
      noteRights: "Bitte beachten Sie den Rechtehinweis",
      noteRights_plural: "Bitte beachten Sie die Rechtehinweise",
      openDialog: "Einstellungsdialog öffnen",
      options: "Optionen",
      preview: {
        label: "Vorschau",
        link: "Mit oben ausgewählten Optionen anzeigen",
      },
      quality: {
        bitonal: "bitonal",
        color: "farbig",
        default: "Voreinstellung",
        gray: "in Graustufen",
        label: "Qualität",
      },
      reflection: "Spiegelung",
      rotation: "Rotation",
      share: {
        envelope: "Per Mail teilen",
        facebook: "Auf Facebook teilen",
        pinterest: "Auf Pinterest teilen",
        twitter: "Auf Twitter teilen",
        whatsapp: "Per WhatsApp teilen",
      },
      size: "Größe",
    },
  },
  en: {
    imageCropper: {
      activate: "Activate selection of an image region",
      close: "Close",
      copiedToClipboard: "Copied successfully to the clipboard",
      copyToClipboard: "Copy to the clipboard",
      deactivate: "Deactivate selection of an image region",
      linkToSelectedRegion: "Link to the selected region",
      mirror: "Mirror image",
      noteRights: "Please note the rights statement",
      noteRights_plural: "Please note the rights statements",
      openDialog: "Open settings dialog",
      options: "Options",
      preview: {
        label: "Preview",
        link: "Show with options selected above",
      },
      quality: {
        bitonal: "bitonal",
        color: "colored",
        default: "preset",
        gray: "in grayscale",
        label: "Quality",
      },
      reflection: "Reflection",
      rotation: "Rotation",
      share: {
        envelope: "Share via mail",
        facebook: "Share on Facebook",
        pinterest: "Share on Pinterest",
        twitter: "Share on Twitter",
        whatsapp: "Share via WhatsApp",
      },
      size: "Size",
    },
  },
};
